import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetBase64 } from 'src/app/common/models/ai-reports/shared/assets';
import { AbstractAssetComponent } from '../abstract-asset.component';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-asset-base64',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './asset-base64.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetBase64Component extends AbstractAssetComponent<AssetBase64> {

	// Construct image URL from asset ID (not storagePath).
	// Base64 assets are looked up globally by ID; the thread context is provided via cookies (projecttoken, thread_id)
	// so the backend can verify permission without needing thread_id in the URL.
	getUrl(): string {
		const a = this.asset();
		return `${environment.apiBaseUrl}${environment.endpoint.assets.image}/${a.id}`;
	}
}
